import { ExtendedQuestionnaireBlock } from '../components/compliance/ExtendedQuestionnaire';

export const SDLC_SECURITY_SELF_ASSESSMENT_BLOCKS: ExtendedQuestionnaireBlock[] = [
  {
    id: 'sdlc-governance',
    name_en: 'SDLC Governance',
    name_es: 'Gobernanza SDLC',
    name_ru: 'Управление SDLC',
    questions: [
      { id: 'sdlc_g1', blockId: 'sdlc-governance', text_en: 'Is there a documented SDLC policy?', text_es: '¿Existe una política SDLC documentada?', text_ru: 'Есть ли задокументированная политика SDLC?' },
      { id: 'sdlc_g2', blockId: 'sdlc-governance', text_en: 'Are developers required to follow secure coding guidelines (OWASP/SEI)?', text_es: '¿Los desarrolladores deben seguir guías de codificación segura (OWASP/SEI)?', text_ru: 'Обязаны ли разработчики следовать руководствам по безопасному кодированию (OWASP/SEI)?' },
      { id: 'sdlc_g3', blockId: 'sdlc-governance', text_en: 'Is threat-modeling required for all critical changes?', text_es: '¿Se requiere threat-modeling para cambios críticos?', text_ru: 'Требуется ли threat modeling для критичных изменений?' },
    ],
  },
  {
    id: 'sdlc-code',
    name_en: 'Code Security',
    name_es: 'Seguridad de Código',
    name_ru: 'Безопасность кода',
    questions: [
      { id: 'sdlc_c1', blockId: 'sdlc-code', text_en: 'Is SAST integrated in CI/CD?', text_es: '¿SAST integrado en CI/CD?', text_ru: 'Интегрирован ли SAST в CI/CD?' },
      { id: 'sdlc_c2', blockId: 'sdlc-code', text_en: 'Is DAST executed before major releases?', text_es: '¿DAST ejecutado antes de releases mayores?', text_ru: 'Выполняется ли DAST перед крупными релизами?' },
      { id: 'sdlc_c3', blockId: 'sdlc-code', text_en: 'Are software dependencies scanned (SCA)?', text_es: '¿Se escanean dependencias de software (SCA)?', text_ru: 'Сканируются ли зависимости ПО (SCA)?' },
    ],
  },
  {
    id: 'sdlc-access-secrets',
    name_en: 'Access & Secrets',
    name_es: 'Acceso y Secretos',
    name_ru: 'Доступ и секреты',
    questions: [
      { id: 'sdlc_a1', blockId: 'sdlc-access-secrets', text_en: 'Are secrets stored securely (vault)?', text_es: '¿Los secretos se almacenan de forma segura (vault)?', text_ru: 'Хранятся ли секреты безопасно (vault)?' },
      { id: 'sdlc_a2', blockId: 'sdlc-access-secrets', text_en: 'Are environments isolated (dev/test/prod)?', text_es: '¿Entornos aislados (dev/test/prod)?', text_ru: 'Изолированы ли окружения (dev/test/prod)?' },
    ],
  },
  {
    id: 'sdlc-deployment',
    name_en: 'Deployment Security',
    name_es: 'Seguridad de Despliegue',
    name_ru: 'Безопасность развёртывания',
    questions: [
      { id: 'sdlc_d1', blockId: 'sdlc-deployment', text_en: 'Is rollback strategy documented?', text_es: '¿Estrategia de rollback documentada?', text_ru: 'Документирована ли стратегия отката?' },
      { id: 'sdlc_d2', blockId: 'sdlc-deployment', text_en: 'Is infrastructure as code used (IaC)?', text_es: '¿Se usa infraestructura como código (IaC)?', text_ru: 'Используется ли инфраструктура как код (IaC)?' },
    ],
  },
];

export const SDLC_SECURITY_QUESTIONNAIRES = {
  SELF_ASSESSMENT: SDLC_SECURITY_SELF_ASSESSMENT_BLOCKS,
};
